/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetCounselingMedicalInformationImagesResponse,
  GetCounselingMedicalInformationImagesResponseFromJSON,
  GetCounselingMedicalInformationImagesResponseToJSON,
  PharmacyCounselorCustomBadRequest5,
  PharmacyCounselorCustomBadRequest5FromJSON,
  PharmacyCounselorCustomBadRequest5ToJSON,
  PharmacyCounselorCustomGatewayTimeout1,
  PharmacyCounselorCustomGatewayTimeout1FromJSON,
  PharmacyCounselorCustomGatewayTimeout1ToJSON,
  PutMedicalInformationRequestBody,
  PutMedicalInformationRequestBodyFromJSON,
  PutMedicalInformationRequestBodyToJSON,
  PutMedicalInformationResponse,
  PutMedicalInformationResponseFromJSON,
  PutMedicalInformationResponseToJSON,
} from "../models";

export interface DeleteMedicalInformationRequest {
  counselingId: number;
  file: string;
}

export interface GetCounselingMedicalInformationImagesRequest {
  counselingId: number;
}

export interface PutMedicalInformationRequest {
  counselingId: number;
  putMedicalInformationRequestBody: PutMedicalInformationRequestBody;
}

/**
 *
 */
export class MedicalInformationApi extends runtime.BaseAPI {
  /**
   * Delete medical information images
   */
  async deleteMedicalInformationRaw(
    requestParameters: DeleteMedicalInformationRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling deleteMedicalInformation."
      );
    }

    if (requestParameters.file === null || requestParameters.file === undefined) {
      throw new runtime.RequiredError(
        "file",
        "Required parameter requestParameters.file was null or undefined when calling deleteMedicalInformation."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/medical-informations/{file}`
          .replace(`{${"counseling_id"}}`, encodeURIComponent(String(requestParameters.counselingId)))
          .replace(`{${"file"}}`, encodeURIComponent(String(requestParameters.file))),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete medical information images
   */
  async deleteMedicalInformation(
    requestParameters: DeleteMedicalInformationRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    await this.deleteMedicalInformationRaw(requestParameters, initOverrides);
  }

  /**
   * Get signed URLs for medical information images
   */
  async getCounselingMedicalInformationImagesRaw(
    requestParameters: GetCounselingMedicalInformationImagesRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetCounselingMedicalInformationImagesResponse>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling getCounselingMedicalInformationImages."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/medical-information-images`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      GetCounselingMedicalInformationImagesResponseFromJSON(jsonValue)
    );
  }

  /**
   * Get signed URLs for medical information images
   */
  async getCounselingMedicalInformationImages(
    requestParameters: GetCounselingMedicalInformationImagesRequest,
    initOverrides?: RequestInit
  ): Promise<GetCounselingMedicalInformationImagesResponse> {
    return promiseRetry(
      (retry) =>
        this.getCounselingMedicalInformationImagesRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Upload multiple medical information images
   */
  async putMedicalInformationRaw(
    requestParameters: PutMedicalInformationRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PutMedicalInformationResponse>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling putMedicalInformation."
      );
    }

    if (
      requestParameters.putMedicalInformationRequestBody === null ||
      requestParameters.putMedicalInformationRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putMedicalInformationRequestBody",
        "Required parameter requestParameters.putMedicalInformationRequestBody was null or undefined when calling putMedicalInformation."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/medical-informations`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutMedicalInformationRequestBodyToJSON(requestParameters.putMedicalInformationRequestBody),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PutMedicalInformationResponseFromJSON(jsonValue));
  }

  /**
   * Upload multiple medical information images
   */
  async putMedicalInformation(
    requestParameters: PutMedicalInformationRequest,
    initOverrides?: RequestInit
  ): Promise<PutMedicalInformationResponse> {
    return promiseRetry(
      (retry) =>
        this.putMedicalInformationRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
